<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        List Card
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <div class="content__tools-wrap">
    <div class="content__row">
      <div class="c-input-check-inline">
        <ng-container *ngIf="!isBrowser; else inputOptionControls">
          <form action="/list-card" method="get">
            <ng-container *ngTemplateOutlet="inputOptionControls"></ng-container>
            <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button><br>
          </form>
          <h2>Note: You are in noJS mode, So please hit submit after the options changes.</h2>
        </ng-container>
      </div>
    </div>
  </div>
  <maced-list-card listCardId="listCardId" name="listCardCheckbox"
    cardAriaLabel="1" cardRole="region"
    [icon]="withoutDragActions && showIconClass ? 'icon-check-circle' : ''" [title]="title" [ariaLabel]="title"
    [hasDraggable]="withoutDragActions && !showIconClass" [hasSelectable]="withoutDragActions && !showIconClass"
    iconTitle="Complete" draggableTitle="Draggable">
    <ng-container ngProjectAs="[listCardDecription]">
      <ul class="c-list-card__content-list">
        <li class="c-list-card__content-list-item" *ngFor="let label of labelList">
          <span class="c-list-card__content-list-label" *ngIf="label?.label"> {{label?.label}}:</span>
          {{label?.placeholder}}
          <em class="u-icon c-list-card__content-list-icon" role="img" aria-label="Plus" [ngClass]="label.icon" *ngIf="label.icon"></em>
        </li>
      </ul>
    </ng-container>
    <ng-container ngProjectAs="[listCardAction]">
      <div class="c-list-card__buttons-item">
        <maced-button buttonId="Secondary1" label="Primary Action" url="/list-card" type="link" color="secondary"
          ariaLabel="Primary Action">
        </maced-button>
      </div>
      <div class="c-list-card__buttons-item">
        <maced-button buttonId="Secondary2" label="Tertiary Action" url="/list-card" type="link" color="tertiary"
          ariaLabel="Tertiary Action">
        </maced-button>
      </div>
      <div class="c-list-card__buttons-item">
        <maced-dropdown dropdownId="dropdownId1" name="dropdownId1" ariaLabel="Dropdown"
          cheveronClass="icon-dots-vertical" [options]="options">
        </maced-dropdown>
      </div>
    </ng-container>
  </maced-list-card>
</div>
<ng-template #inputOptionControls>
  <input id="showIconClass" class="c-input-check-inline__input" type="checkbox" name="showIconClass"
    [(ngModel)]="showIconClass">
  <label for="showIconClass" class="c-input-check-inline__label u-mr-15">
    Show Icon
  </label>

  <input id="withoutDragActions" class="c-input-check-inline__input" type="checkbox" name="withoutDragActions"
    [(ngModel)]="withoutDragActions">
  <label for="withoutDragActions" class="c-input-check-inline__label u-mr-15">
    Without Drag Actions
  </label>
</ng-template>